import {createSlice} from '@reduxjs/toolkit'

const initialState = {
  mapInstance: null
}

const mapSlice = createSlice({
  name: 'map',
  initialState,
  reducers: {
    setMapInstance: (state, action) => {
      state.mapInstance = action.payload
    }
  }
})

export const {setMapInstance} = mapSlice.actions

export const selectMapInstance = (state) => state.map?.mapInstance ?? null

export default mapSlice.reducer
